import {SelectItem} from '@cypro/ui/components/form/select'
import {readRuntimeFlag} from '@cypro/ui/hooks/use-current-env'

export const localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone

// Flags are read from window.__RUNTIME_FLAGS__ (public/runtime-flags.js) rather than
// import.meta.env directly: Vite inlines VITE_* as build-time literals, so a `=== 'true'` check
// would be constant-folded before Caddy can substitute the real value at container start.
export const FLAGS = {
  blockPatientInsert: readRuntimeFlag(window.__RUNTIME_FLAGS__?.blockPatientInsert, import.meta.env.VITE_BLOCK_PATIENT_INSERT),
  blockStockBatchInsert: readRuntimeFlag(
    window.__RUNTIME_FLAGS__?.blockStockBatchInsert,
    import.meta.env.VITE_BLOCK_STOCK_BATCH_INSERT
  ),
  smartCompounder: readRuntimeFlag(window.__RUNTIME_FLAGS__?.smartCompounder, import.meta.env.VITE_SMART_COMPOUNDER_ENABLED),
}
export const bsaFormulasOptions = [
  {value: 'DU_BOIS', label: 'Du Bois & Du Bois'},
  {value: 'MOSTELLER', label: 'Mosteller'},
  {value: 'HAYCOCK', label: 'Haycock'},
] as SelectItem[]

export const ibwFormulasOptions = [
  {value: 'DEVINE', label: 'Devine'},
  {value: 'ROBINSON', label: 'Robinson'},
  {value: 'MILLER', label: 'Miller'},
] as SelectItem[]
